(function () {
  angular.module("akitabox.ui.dialogs.assetExportJob", [
    "ngMaterial",
    "akitabox.core.services.building",
    "akitabox.core.services.organization",
    "akitabox.core.services.job.job",
  ]);
})();
